<script setup>
import { useDayjs } from '@daysmart/daysmart-vue-components/composables'
import { useCalendarViewState } from '../composables/useCalendarViewState'

const props = defineProps({
  data: Array,
  getGroupKey: Function,
  getGroupKeySort: {
    type: Function,
    required: false,
  },
  initialGroupKeys: {
    type: Array,
    required: false,
  },
  keyCompareFunction: {
    type: Function,
    required: false,
  },
  isClosed: {
    type: [Boolean, Function],
    default: undefined,
    required: false,
  },
})

const view = useCalendarViewState()
const dayjs = useDayjs()

function getIsClosed(day) {
  if (typeof props.isClosed === 'function')
    return props.isClosed(day)
}

const initialGroupTimeKeys = computed(() => {
  return [
    ...new Set(props.data?.map(event => event.starts_at.slice(11, 16))),
  ].sort((a, b) => a.localeCompare(b))
})
</script>

<template>
  <div>
    <slot name="header" />
    <DSGroupedDataTemplate
      v-slot="{
        key: timeKey,
        data: timeData,
        isFirst: isFirstRow,
        isLast: isLastRow,
      } = {}"
      :data="data"
      :initial-group-keys="initialGroupTimeKeys"
      :get-group-key="event => event.starts_at.slice(11, 16)"
    >
      <div
        class="group group-inner flex flex-col bg-surface-600 last:(border-b-1 border-surface-600 rounded-8px) first:b-rounded-t-8px"
        :timeKey="timeKey"
      >
        <ScheduleViewRowHeader
          class="group-[:first-child]:b-rounded-t-8px"
          :time="`0001-01-01T${timeKey}`"
        />
        <DSGroupedDataTemplate
          v-slot="{
            data: groupData,
            key: groupKey,
            isFirst: isFirstCol,
            isLast: isLastCol,
          } = {}"
          class="flex flex-row flex-gap-1px px-1px"
          :data="timeData"
          :get-group-key="getGroupKey"
          :initial-group-keys="initialGroupKeys"
          :key-compare-function="keyCompareFunction"
        >
          <ScheduleEventItemContainer
            :group-key="groupKey"
            :class="{
              'rounded-bl-8px': isLastRow && isFirstCol,
              'rounded-br-8px': isLastRow && isLastCol,
            }"
          >
            <ScheduleClosedSign v-if="getIsClosed(groupKey)" />
            <ScheduleEventItem
              v-for="event in groupData"
              :event="event"
            />
          </ScheduleEventItemContainer>
        </DSGroupedDataTemplate>
      </div>
    </DSGroupedDataTemplate>
  </div>
</template>
